import { useQuery } from 'react-query'
import { apiFetchUsage } from '../api/usage-monitor'

export const useGetUsageData = (startTime, endTime, eventType) => {
  const {
    status,
    data: allUsageData,
    error,
    isLoading,
    refetch,
  } = useQuery(
    ['usage-monitor', startTime, endTime, eventType],
    async () => {
      const result = await apiFetchUsage({
        start_time: startTime,
        end_time: endTime,
        event_type: eventType,
      })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!startTime && !!endTime,
      retry: false,
    },
  )
  return { status, allUsageData, isLoading, error, refetch }
}
